import React, { useRef, useState, useEffect } from 'react'
import Dropdown from '../../../../partials/Dropdown'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import Api from '../../../../../_helpers/Api'
import editIcon from '../../../../../assets/img/icons/edit-yellow.png'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../../_providers/Translation'
import NoDataFound from '../../../../partials/NoDataFound'


function FeedbackEmail(props) {
    const auth = useAuthDataContext()
    const [state, setState] = useState({
        loading: true,
        data: null,
        update: false,
    })

    // Form state for new settings
    const [form, setForm] = useState({
        initial_status: '',
        final_status: '',
        content: '',
        review_link: '',
    })

    // Statuses for dropdowns
    const [initialStatuses, setInitialStatuses] = useState([])
    const [finalStatuses, setFinalStatuses] = useState([])

    useEffect(() => {
        loadSettings()
        loadStatuses()
    }, [state.update])

    // Sync form state with loaded data
    useEffect(() => {
        if (state.data && Object.keys(state.data).length > 0) {
            setForm({
                initial_status: state.data.initial_reservation_status_id || '',
                final_status: state.data.final_reservation_status_id || '',
                content: state.data.content || '',
                review_link: state.data.review_link || '',
            })
        }
    }, [state.data])

    const loadSettings = () => {
        Api.get('settings/feedback-email?partner_id=' + auth.partnerId())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }))
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const loadStatuses = () => {
        Api.get('reservations/initial-and-final-statuses')
            .then(res => {
                setInitialStatuses(Array.isArray(res.data?.initial) ? res.data.initial : [])
                setFinalStatuses(Array.isArray(res.data?.final) ? res.data.final : [])
            })
    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const [formLoading, setFormLoading] = useState(false)
    const [formError, setFormError] = useState(null)

    const handleFormChange = e => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const handleFormSubmit = e => {
        e.preventDefault()
        setFormLoading(true)
        setFormError(null)
        Api.post('settings/feedback-email', form)
            .then(() => {
                setFormLoading(false)
                handleUpdate()
            })
            .catch(err => {
                setFormLoading(false)
                setFormError(trans('messages.saveError') || 'Грешка при запис.')
            })
    }

    // Modal functionality removed as requested

    // Use fetched arrays for dropdowns
    const initialStatusOptions = initialStatuses
    const finalStatusOptions = finalStatuses

    // Always show the form, pre-filled if data exists
    return (
        <div style={{ width: '100%' }}>
            <div className="head">
                <h3>{trans('headings.sendingEmailsForClientFeedback')}</h3>
            </div>
            <hr />
            {state.loading ? (
                <Skeleton height={35} count={5} />
            ) : (
                <form className="review-email-settings-form" onSubmit={handleFormSubmit}>
                    <h3>
                        {trans('subheadings.criteriaForSendingEmailsToClients')}
                    </h3>
                    <div className="row">
                        <div className="col">
                            <label htmlFor="initial_status">
                                {trans('labels.initialStatus') || 'Първоначален статус на резервацията'}
                            </label>
                            <select
                                id="initial_status"
                                name="initial_status"
                                value={form.initial_status}
                                onChange={handleFormChange}
                                required
                            >
                                <option value="">{trans('labels.chooseStatus') || 'Изберете статус'}</option>
                                {initialStatusOptions.map(opt => (
                                    <option key={opt.id} value={opt.id}>
                                        {opt.translation?.name || opt.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col">
                            <label htmlFor="final_status">
                                {trans('labels.finalStatus') || 'Финален статус на резервацията'}
                            </label>
                            <select
                                id="final_status"
                                name="final_status"
                                value={form.final_status}
                                onChange={handleFormChange}
                                required
                            >
                                <option value="">{trans('labels.chooseStatus') || 'Изберете статус'}</option>
                                {finalStatusOptions.map(opt => (
                                    <option key={opt.id} value={opt.id}>
                                        {opt.translation?.name || opt.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <label htmlFor="content">
                                {trans('labels.content') + ' *' || 'Съдържание *'}
                            </label>
                            <textarea
                                id="content"
                                name="content"
                                required
                                rows={5}
                                value={form.content}
                                onChange={handleFormChange}
                                placeholder={trans('labels.content') || 'Съдържание'}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <label htmlFor="review_link">
                                {trans('labels.reviewLink') || 'Линк за оставяне на отзив'}
                            </label>
                            <input
                                id="review_link"
                                name="review_link"
                                type="url"
                                required
                                value={form.review_link}
                                onChange={handleFormChange}
                                placeholder={trans('labels.reviewLink') || 'Линк за оставяне на отзив'}
                                style={{ width: '100%', borderRadius: 4, border: '1px solid #ccc', padding: 8 }}
                            />

                        </div>
                    </div>
                    {formError &&
                        <div className='row'>
                            <div className='col'>
                                <div style={{ color: 'red', marginBottom: 12 }}>{formError}</div>
                            </div>
                        </div>}
                    <div className='row'>
                        <button className="button button-primary" type="submit" disabled={formLoading}>
                            {formLoading ? (trans('labels.loading')) : (trans('buttons.save') || 'Запази')}
                        </button>
                    </div>
                </form>
            )}
        </div>
    )
}

export default FeedbackEmail
